import { render, staticRenderFns } from "./CustomConfirmModal.vue?vue&type=template&id=2d6b4d80&scoped=true&"
import script from "./CustomConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./CustomConfirmModal.vue?vue&type=script&lang=ts&"
import style0 from "./CustomConfirmModal.vue?vue&type=style&index=0&id=2d6b4d80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6b4d80",
  null
  
)

export default component.exports